@if(isTitle) {
  <div class="ols-fake-item__title">&nbsp;</div>
} @else if (isTekstLong) {
  <div class="ols-fake-item__tekst1">&nbsp;</div>
}
@else {
  <div class="ols-fake-item__tekst2">&nbsp;</div>
}